import { render } from "./OurSlide.vue?vue&type=template&id=207c333a"
import script from "./OurSlide.vue?vue&type=script&lang=js"
export * from "./OurSlide.vue?vue&type=script&lang=js"

import "./OurSlide.vue?vue&type=style&index=0&id=207c333a&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__